import { useState, useEffect } from 'react';
import { toastr } from 'react-redux-toastr';
import UserRepository from '../../../repositories/UserRepository';
import { stripSensitiveParams } from '../../../utils/urlToken';

export const useNewPassword = ({ handleOption, location }) => {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [notMatch, setNotMatch] = useState(false);
  const [userHash, setUserHash] = useState(null);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    checkURL();
  }, []);

  const checkURL = () => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      setUserHash(token);
      stripSensitiveParams();
    } else {
      handleOption(0);
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    setNotMatch(false);

    if (password !== confirmPassword) {
      setLoading(false);
      setNotMatch(true);
      return;
    }

    try {
      await UserRepository.updatePassword({ token: userHash, password });
      toastr.success('Senha alterada com sucesso!');
      setFinished(true);
    } catch (err) {
      toastr.error(
        'Erro ao tentar alterar a senha',
        err.response?.data?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    notMatch,
    handleUpdate,
    finished,
  };
};
